export interface Post {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: number;
  likes: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  postCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '生活点滴',
    slug: 'life',
    description: '记录日常生活中的温暖瞬间与美好发现',
    icon: 'ri-heart-line',
    postCount: 128,
  },
  {
    id: 'cat-2',
    name: '情感天地',
    slug: 'emotion',
    description: '分享内心的情感故事，倾诉心声，寻找共鸣',
    icon: 'ri-chat-smile-2-line',
    postCount: 96,
  },
  {
    id: 'cat-3',
    name: '兴趣圈子',
    slug: 'hobby',
    description: '摄影、读书、旅行、美食⋯⋯找到你的同好',
    icon: 'ri-palette-line',
    postCount: 84,
  },
  {
    id: 'cat-4',
    name: '故事分享',
    slug: 'story',
    description: '用文字讲述那些打动人心的人间故事',
    icon: 'ri-book-open-line',
    postCount: 72,
  },
  {
    id: 'cat-5',
    name: '职场交流',
    slug: 'career',
    description: '职业发展、职场经验、行业洞察与互助',
    icon: 'ri-briefcase-line',
    postCount: 56,
  },
  {
    id: 'cat-6',
    name: '互助问答',
    slug: 'help',
    description: '有问题？来这里，社区成员热心为你解答',
    icon: 'ri-question-answer-line',
    postCount: 110,
  },
];

export const posts: Post[] = [
  {
    id: 'post-1',
    slug: 'nanwang-de-lvxing-jingli',
    title: '那次说走就走的旅行，改变了我对生活的看法',
    excerpt: '去年秋天，我做了一个疯狂的决定——辞掉工作，背起行囊，踏上了一段没有计划的旅程。三十天，七个城市，无数个陌生人，让我重新理解了什么是真正的生活。',
    content: `<p>去年秋天，我做了一个疯狂的决定——辞掉工作，背起行囊，踏上了一段没有计划的旅程。</p>
<p>出发前的那天晚上，我躺在床上翻来覆去睡不着。脑海里全是各种担忧：工作怎么办？钱够不够花？一个人会不会太孤单？但内心深处有个声音一直在说：去吧，趁现在还年轻。</p>
<p>第一站是成都。在宽窄巷子的茶馆里，我遇到了一位七十多岁的老大爷。他说自己年轻时也像我一样，背个包就走遍了大半个中国。"小伙子，人生不在于活了多久，而在于活得多精彩。"这句话让我至今难忘。</p>
<p>在大理，我住进了一家青旅。老板是个辞职创业的北京姑娘，她把自己对生活的热爱融入了每一处细节。院子里种满了花，墙上挂着来自世界各地旅行者的留言。那种自由又温暖的感觉，让我第一次体会到什么叫"诗意地栖居"。</p>
<p>最让我感动的是在丽江遇到的一对老夫妻。他们已经结婚五十年了，每年都会一起旅行。老爷子腿脚不太方便，老太太就搀着他慢慢走。他们坐在古城的石阶上，看着夕阳，手牵着手，什么话也没说。那一刻我忽然明白，最美的风景不是山不是水，而是有个人愿意陪你一起看。</p>
<p>三十天的旅程结束了，但生活的旅程才刚刚开始。回到城市后，我换了份更喜欢的工作，开始学摄影，周末会去探索城市里不曾注意的角落。这趟旅行教会我的，不只是如何收拾行囊，更是如何收拾心情，去拥抱生活中的每一个未知。</p>
<p>如果你也在犹豫要不要出发，我的建议是：别想太多，先走出去。路上会有答案的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20artistic%20travel%20scene%20with%20a%20person%20walking%20on%20a%20sunlit%20ancient%20cobblestone%20street%20in%20a%20traditional%20Chinese%20old%20town%2C%20golden%20afternoon%20light%2C%20soft%20warm%20tones%2C%20impressionist%20style%2C%20dreamy%20atmosphere%2C%20travel%20and%20freedom%20concept%2C%20minimal%20composition&width=1600&height=900&seq=post-cover-1&orientation=landscape',
    category: '生活点滴',
    categorySlug: 'life',
    author: '远方的风',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20portrait%20of%20a%20young%20Asian%20person%20with%20gentle%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20artistic%20photography%20style&width=200&height=200&seq=avatar-1&orientation=squarish',
    publishDate: '2026-08-10',
    readTime: 8,
    likes: 1286,
    comments: 342,
    tags: ['旅行', '生活感悟', '成长'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'post-2',
    slug: 'sanshisui-de-rensheng-jiaolv',
    title: '三十岁的我们，为什么越来越焦虑？',
    excerpt: '房贷、车贷、职场竞争、婚恋压力⋯⋯三十岁的这一代人，似乎背负着前所未有的重担。今天，我们来聊聊这些焦虑背后的真相。',
    content: `<p>前几天，大学同学群里突然热闹起来。起因是一个同学发了条消息："兄弟们，我昨晚失眠了，想想自己三十岁了，啥也没干成，好焦虑。"</p>
<p>没想到这条消息炸出了潜水多年的老同学们。大家纷纷表示同感——三十岁这个坎，谁都绕不过去。</p>
<p><strong>焦虑一：事业不上不下</strong></p>
<p>小明在互联网大厂干了五年，月薪两万多。"看起来不错对吧？但每天加班到半夜，身体越来越差，想跳槽又怕找不到更好的。最可怕的是，感觉自己随时可能被更年轻的人替代。"</p>
<p><strong>焦虑二：买房遥遥无期</strong></p>
<p>在一线城市工作的同龄人，几乎都在为房子发愁。首付攒了好几年，房价却涨得更快。有人开玩笑说："我的人生规划就是：先活到房价崩盘那天。"</p>
<p><strong>焦虑三：婚恋压力山大</strong></p>
<p>"每次回家过年，我妈都恨不得把整个村的单身男青年介绍给我。"小红苦笑着说。三十岁单身，在父母眼里仿佛天要塌下来了。</p>
<p>但是朋友们，当我们冷静下来想一想：这些焦虑真的都是我们自己的吗？还是说，我们一直在用别人的标准来衡量自己的人生？</p>
<p>每个人都有自己的节奏。有人25岁就当了CEO，有人40岁才开始创业。有人单身一辈子也很精彩，有人结婚十年才遇到对的人。人生的精彩之处，恰恰在于它的不可预测和独一无二。</p>
<p>与其焦虑未来，不如专注当下。做好手头的事，爱身边的人，保持健康的身体和积极的心态。这些，才是对抗焦虑最好的武器。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20thoughtful%20person%20sitting%20by%20a%20window%20in%20a%20cozy%20modern%20apartment%2C%20rain%20on%20the%20glass%2C%20warm%20indoor%20lighting%2C%20contemplative%20mood%2C%20soft%20amber%20and%20cream%20tones%2C%20cinematic%20photography%20style%2C%20urban%20life%20concept&width=1600&height=900&seq=post-cover-2&orientation=landscape',
    category: '情感天地',
    categorySlug: 'emotion',
    author: '城市夜归人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20woman%20with%20short%20hair%2C%20gentle%20expression%2C%20soft%20lighting%2C%20cream%20background%2C%20artistic%20style&width=200&height=200&seq=avatar-2&orientation=squarish',
    publishDate: '2026-08-09',
    readTime: 6,
    likes: 956,
    comments: 278,
    tags: ['三十岁', '焦虑', '人生感悟', '成长'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'post-3',
    slug: 'sheying-ruhe-ru-men',
    title: '摄影入门指南：用手机也能拍出好照片',
    excerpt: '不需要昂贵的器材，你的手机就是最好的创作工具。从构图到光线，从后期到审美，这篇指南帮你快速入门摄影世界。',
    content: `<p>很多人以为玩摄影一定要有专业的相机和镜头，其实这是个误区。现在手机的拍照功能越来越强大，对于初学者来说，手机完全够用了。</p>
<p><strong>第一步：学会观察光线</strong></p>
<p>摄影是用光的艺术。同样的场景，不同的光线会呈现完全不同的效果。清晨和傍晚的"黄金时刻"，光线柔和温暖，是拍摄的最佳时机。正午的强光会产生难看的阴影，尽量避免。</p>
<p><strong>第二步：掌握基本构图</strong></p>
<p>三分法是最基础也最实用的构图技巧。把画面横竖各分成三等份，把主体放在交叉点上，照片会立刻变得更有层次感。另外，注意留白——不要把画面塞得太满。</p>
<p><strong>第三步：寻找独特视角</strong></p>
<p>与其站着平拍，不如蹲下来仰拍或者找个高处俯拍。换个角度，世界会呈现出完全不同的面貌。最普通的街景，从蚂蚁的视角来看也会很震撼。</p>
<p><strong>第四步：后期让照片更出彩</strong></p>
<p>后期不是造假，而是还原你当时眼睛看到的美丽。手机自带的编辑功能就很好用，调整亮度、对比度、饱和度，再加一点暖色调，照片会立刻变得有质感。</p>
<p>最重要的还是多拍多练。每天拍一张照片，坚持一个月，你会发现自己的进步超乎想象。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20minimalist%20flat%20lay%20of%20a%20smartphone%20displaying%20a%20beautiful%20photo%20on%20screen%2C%20surrounded%20by%20warm%20natural%20elements%20like%20dried%20flowers%20and%20a%20cup%20of%20coffee%2C%20soft%20morning%20light%2C%20cream%20and%20terracotta%20tones%2C%20cozy%20creative%20vibe&width=1600&height=900&seq=post-cover-3&orientation=landscape',
    category: '兴趣圈子',
    categorySlug: 'hobby',
    author: '镜头里的世界',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20man%20with%20glasses%2C%20friendly%20smile%2C%20holding%20a%20camera%2C%20soft%20lighting%2C%20cream%20background&width=200&height=200&seq=avatar-3&orientation=squarish',
    publishDate: '2026-08-08',
    readTime: 5,
    likes: 723,
    comments: 156,
    tags: ['摄影', '手机摄影', '入门教程'],
    isHot: false,
    isFeatured: true,
  },
  {
    id: 'post-4',
    slug: 'beipiao-shinian-de-gushi',
    title: '北漂十年：我终于在这座城市找到了归属感',
    excerpt: '从地下室到两居室，从月薪三千到年薪三十万，十年的北漂生活教会了我一件事——归属感不是别人给的，是自己挣的。',
    content: `<p>十年前，我拖着一个行李箱，坐了十几个小时的火车来到北京。那时的我，兜里只有两千块钱，心里只有一个模糊的梦想。</p>
<p>前三年是最难的。住过地下室，啃过馒头就咸菜，被中介骗过，被老板骂哭过。有无数次想放弃，想回老家考个公务员算了。但每次想到当初为什么出发，就又咬牙坚持了下来。</p>
<p>转机出现在第四年。我遇到了一个很好的领导，他教会了我很多东西。我开始主动学习新技能，周末去参加各种行业活动，慢慢地，机会开始找上门来。</p>
<p>现在回头看，北漂这十年，最大的收获不是物质上的，而是我变成了一个更强大的人。我学会了独立做决定，学会了面对困难不退缩，学会了在陌生环境中建立自己的社交圈。</p>
<p>这座城市不再是一个冷冰冰的地名，而是承载了我青春、汗水和梦想的地方。归属感，就是这样一点点积累起来的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20cityscape%20of%20a%20modern%20Chinese%20city%20at%20sunset%2C%20golden%20light%20on%20buildings%2C%20a%20person%20looking%20out%20from%20a%20high%20balcony%2C%20hopeful%20and%20reflective%20mood%2C%20soft%20warm%20tones%2C%20cinematic%20composition&width=1600&height=900&seq=post-cover-4&orientation=landscape',
    category: '故事分享',
    categorySlug: 'story',
    author: '追梦人小陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20middle-aged%20Asian%20man%20with%20confident%20expression%2C%20modern%20office%20background%2C%20soft%20lighting%2C%20professional%20yet%20friendly&width=200&height=200&seq=avatar-4&orientation=squarish',
    publishDate: '2026-08-07',
    readTime: 7,
    likes: 1542,
    comments: 489,
    tags: ['北漂', '城市生活', '成长故事'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'post-5',
    slug: 'jiating-he-gongzuo-ruhe-pingheng',
    title: '当妈妈重返职场：家庭与工作的平衡之道',
    excerpt: '孩子三岁那年，我决定重返职场。从全职妈妈到职场女性，这段路走得不容易，但每一步都值得。',
    content: `<p>生完孩子后，我在家当了三年全职妈妈。每天围着孩子转，虽然很幸福，但总觉得自己失去了什么。</p>
<p>重返职场的第一个月是最煎熬的。三年的时间，行业变了，技能生疏了。面试了好几家都被拒，自信心跌到谷底。但我没有放弃，利用晚上的时间学习新知识，逐渐跟上了节奏。</p>
<p>现在我在一家不错的公司做运营主管。虽然每天要六点起床给孩子做早饭、送幼儿园，然后赶地铁上班，晚上回家还要陪孩子讲故事，很累，但很充实。</p>
<p>我的经验是：不要追求完美。家里不需要一尘不染，偶尔叫外卖也没什么。重要的是陪伴的质量，不是时间的长短。孩子看到妈妈在努力追求自己的价值，这对他们来说是最好的教育。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20scene%20of%20a%20mother%20working%20on%20a%20laptop%20at%20a%20cozy%20home%20desk%2C%20a%20child%20playing%20nearby%2C%20soft%20afternoon%20sunlight%20through%20the%20window%2C%20warm%20cream%20and%20beige%20interior%2C%20loving%20family%20atmosphere&width=1600&height=900&seq=post-cover-5&orientation=landscape',
    category: '生活点滴',
    categorySlug: 'life',
    author: '阳光妈妈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20gentle%20smiling%20woman%20in%20her%20thirties%2C%20motherly%20warmth%2C%20soft%20lighting%2C%20cream%20background&width=200&height=200&seq=avatar-5&orientation=squarish',
    publishDate: '2026-08-06',
    readTime: 5,
    likes: 891,
    comments: 203,
    tags: ['职场妈妈', '家庭', '女性成长'],
    isHot: false,
    isFeatured: true,
  },
  {
    id: 'post-6',
    slug: 'yigeren-de-haijiao-riji',
    title: '一个人的海角日记：独处是一种能力',
    excerpt: '在这个喧嚣的世界里，学会与自己独处，或许是我们能给自己最好的礼物。',
    content: `<p>周五晚上，朋友们约我去聚餐，我说有点累了想休息。关上手机，泡了杯茶，翻开一本买了很久却一直没看的书。那一刻，整个世界都安静下来了。</p>
<p>不知道从什么时候开始，我们越来越害怕独处。一个人的时候就会不自觉地刷手机，仿佛停下来就会感到空虚。但其实，独处不是孤独，而是与自己对话的最好时机。</p>
<p>我慢慢学会了享受独处。一个人去电影院看一场想看的电影，一个人去公园散步观察路边的花，一个人在咖啡馆写日记。这些时刻让我更了解自己，也更懂得如何与他人相处。</p>
<p>如果你也害怕独处，不妨从十分钟开始。关掉所有电子设备，只是静静地坐着，感受呼吸，感受当下。你会发现，原来自己才是最有趣的陪伴。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20peaceful%20scene%20of%20a%20person%20sitting%20alone%20by%20a%20large%20window%20overlooking%20the%20ocean%2C%20reading%20a%20book%2C%20warm%20golden%20sunset%20light%2C%20minimalist%20interior%2C%20calm%20and%20serene%20mood%2C%20soft%20warm%20tones&width=1600&height=900&seq=post-cover-6&orientation=landscape',
    category: '情感天地',
    categorySlug: 'emotion',
    author: '海边的小岛',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20person%20with%20thoughtful%20expression%2C%20looking%20at%20the%20ocean%2C%20soft%20lighting%2C%20serene%20vibe&width=200&height=200&seq=avatar-6&orientation=squarish',
    publishDate: '2026-08-05',
    readTime: 4,
    likes: 678,
    comments: 145,
    tags: ['独处', '自我成长', '生活方式'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'post-7',
    slug: 'chushi-sannian-xuehui-de-shi',
    title: '初入职场三年，我学会了这些事',
    excerpt: '从懵懂的应届生到独当一面的职场人，三年时间教会我的不只是专业技能，更是为人处世的智慧。',
    content: `<p>三年前的这个时候，我刚刚拿到毕业证，满怀着对未来的憧憬走进公司。现在回想起来，那时候真是天真得可爱。</p>
<p><strong>第一课：主动沟通比埋头苦干更重要</strong></p>
<p>刚开始我只知道埋头干活，觉得只要把事情做好就行。后来才发现，及时和领导同步进展，让同事知道你的工作状态，比一个人闷头干效率高得多。</p>
<p><strong>第二课：学会说"不"</strong></p>
<p>刚入职时什么活都接，结果样样做不好。后来学会了合理拒绝，把精力集中在最重要的事情上，反而得到了更多的认可。</p>
<p><strong>第三课：保持学习，但别焦虑</strong></p>
<p>这个行业变化太快，永远有新东西要学。与其焦虑跟不上，不如每天进步一点点。三年下来回头看，发现已经走了很远。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20bright%20modern%20open%20office%20space%20with%20warm%20lighting%2C%20young%20professionals%20collaborating%2C%20plants%20and%20natural%20elements%2C%20creative%20workspace%20vibe%2C%20soft%20amber%20and%20cream%20tones&width=1600&height=900&seq=post-cover-7&orientation=landscape',
    category: '职场交流',
    categorySlug: 'career',
    author: '职场新人小李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20professional%20man%20in%20business%20casual%2C%20confident%20smile%2C%20office%20background%2C%20soft%20lighting&width=200&height=200&seq=avatar-7&orientation=squarish',
    publishDate: '2026-08-04',
    readTime: 5,
    likes: 534,
    comments: 128,
    tags: ['职场', '新人', '成长'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'post-8',
    slug: 'ruhe-tisheng-goutong-nengli',
    title: '学会高效沟通，让你的人际关系开挂',
    excerpt: '为什么有的人说话让人如沐春风？沟通不是天赋，而是可以练习的技能。这几个方法，让你的沟通能力快速提升。',
    content: `<p>你有没有遇到过这种情况：明明是好意，说出来却得罪了人？或者开会时想表达观点，却总是插不上话？</p>
<p>沟通是一门可以学习的技能。掌握以下几点，你的人际关系会有质的飞跃。</p>
<p><strong>1. 先听后说</strong></p>
<p>大部分人在听别人说话时，脑子里已经在想怎么回复了。真正有效的倾听，是放下自己的判断，全身心理解对方想表达的意思。试试在对方说完后，先用自己的话复述一遍："你的意思是⋯⋯对吗？"</p>
<p><strong>2. 用"我"代替"你"</strong></p>
<p>"你总是迟到"是指责，"我希望我们能准时开始"是表达需求。前者让人想反驳，后者让人想配合。一个小小的语言转换，效果天差地别。</p>
<p><strong>3. 非暴力沟通四步法</strong></p>
<p>观察→感受→需要→请求。描述客观事实而不评判，表达真实感受而不指责，说出自己的需要，提出具体的请求。这套方法在家庭和工作中都非常好用。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20people%20having%20a%20warm%20conversation%20in%20a%20cozy%20cafe%2C%20soft%20afternoon%20light%20through%20the%20window%2C%20genuine%20smiles%2C%20warm%20cream%20and%20terracotta%20interior%2C%20friendly%20atmosphere&width=1600&height=900&seq=post-cover-8&orientation=landscape',
    category: '互助问答',
    categorySlug: 'help',
    author: '沟通教练老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20friendly%20middle-aged%20man%20with%20kind%20eyes%2C%20professional%20yet%20approachable%2C%20soft%20lighting&width=200&height=200&seq=avatar-8&orientation=squarish',
    publishDate: '2026-08-03',
    readTime: 5,
    likes: 445,
    comments: 98,
    tags: ['沟通', '人际关系', '职场技能'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'post-9',
    slug: 'duzi-yigerende-meishi-tansuo',
    title: '一个人也要好好吃饭：独居美食探索记',
    excerpt: '谁说一个人吃饭就要凑合？从快手早餐到精致晚餐，独居生活的美食探索，让每一天都充满仪式感。',
    content: `<p>很多人觉得一个人做饭太麻烦，点个外卖算了。但我发现，为自己认真做一顿饭，是最好的自我关怀。</p>
<p>我的独居美食心得：</p>
<p><strong>快手早餐：鸡蛋的N种吃法</strong></p>
<p>煎蛋、炒蛋、水波蛋、蛋饼⋯⋯鸡蛋是最百搭的食材。配上吐司和牛油果，五分钟搞定一顿营养早餐。我每周都会尝试一种新的鸡蛋做法，生活永远有新意。</p>
<p><strong>周末慢生活：花两个小时炖一锅汤</strong></p>
<p>周末不用赶时间，我会去菜市场慢悠悠地逛一圈，买新鲜的排骨和蔬菜，回家花两个小时慢慢炖。满屋子飘香的时候，幸福感是外卖给不了的。</p>
<p><strong>小贴士：善用冰箱收纳</strong></p>
<p>独居最大的难题是食材容易浪费。我的方法是周末备好一周的食材，分装冷冻，每天取一份做。省钱又省力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20kitchen%20scene%20with%20a%20beautifully%20plated%20home-cooked%20meal%20on%20a%20wooden%20table%2C%20warm%20lighting%2C%20steam%20rising%20from%20the%20food%2C%20minimalist%20ceramic%20dishware%2C%20cream%20and%20terracotta%20tones%2C%20comforting%20atmosphere&width=1600&height=900&seq=post-cover-9&orientation=landscape',
    category: '生活点滴',
    categorySlug: 'life',
    author: '厨房里的小确幸',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20of%20a%20young%20woman%20in%20a%20kitchen%20apron%2C%20happy%20smile%2C%20holding%20a%20wooden%20spoon%2C%20cozy%20kitchen%20background&width=200&height=200&seq=avatar-9&orientation=squarish',
    publishDate: '2026-08-02',
    readTime: 4,
    likes: 567,
    comments: 134,
    tags: ['美食', '独居生活', '生活方式'],
    isHot: false,
    isFeatured: false,
  },
];

export const getPostBySlug = (slug: string): Post | undefined =>
  posts.find((p) => p.slug === slug);

export const getPostsByCategory = (categorySlug: string): Post[] =>
  posts.filter((p) => p.categorySlug === categorySlug);

export const getHotPosts = (): Post[] =>
  posts.filter((p) => p.isHot).sort((a, b) => b.likes - a.likes);

export const getFeaturedPosts = (): Post[] =>
  posts.filter((p) => p.isFeatured);

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);